import {Display} from "./Display";

export class Slider
{
    constructor(container)
    {
        this.slideTimer = 15000;
        this.slides = container.querySelectorAll('.w__header--slide');
        if(this.slides.length > 1)
        {
            this.activeSlideNo = 0;
            setInterval(() => {
                this.next_slide();
            }, this.slideTimer);
        }
    }

    next_slide()
    {
        let newSlideNo = this.activeSlideNo + 1;
        if(newSlideNo === this.slides.length)
        {
            newSlideNo = 0;
        }
        if(this.slides[newSlideNo].querySelector('.load'))
        {
            this.load_image(newSlideNo);
        }
        else
        {
            this.switch_slide(newSlideNo);
        }
    }

    load_image(newSlideNo)
    {
        const el = this.slides[newSlideNo].querySelector('.load');
        const src = this.adjust_imagePath(
            el.href,
            Display.x);
        const myImage = new Image;
        myImage.classList.add('w__header--image');
        myImage.src = src;
        myImage.alt = '';
        myImage.addEventListener('load',() =>
        {
            el.remove();
            this.slides[newSlideNo].appendChild(myImage);
            this.switch_slide(newSlideNo);
        });
    }

    adjust_imagePath(imgSrc, sizeX)
    {
        sizeX *= Display.dpi;

        let srcPath,
            targetPath;

        if(imgSrc.match(/\/bild\/back\//))
        {
            if(sizeX <= 800)
            {
                targetPath = '800x450';
            }
            else if(sizeX <= 1280)
            {
                targetPath = '1280x720';
            }
            else if(sizeX <= 1600)
            {
                targetPath = '1600x900';
            }
            else if(sizeX <= 1920)
            {
                targetPath = '1920x1080';
            }
            else
            {
                targetPath = '2560x1440';
            }
            targetPath = '/bild/back/' + targetPath + "/";

            if(imgSrc.match(/\/800x450\//))
            {
                srcPath = '800x450';
            }
            else if(imgSrc.match(/\/1280x720\//))
            {
                srcPath = '1280x720';
            }
            else if(imgSrc.match(/\/1600x900\//))
            {
                srcPath = '1600x900';
            }
            else if(imgSrc.match(/\/1920x1080\//))
            {
                srcPath = '1920x1080';
            }
            else
            {
                srcPath = '2560x1440';
            }
            srcPath = '/bild/back/' + srcPath + "/";
        }
        else if(imgSrc.match(/\/bild\/header\//))
        {
            if(sizeX <= 448)
            {
                targetPath = '448x175';
            }
            else if(sizeX <= 768)
            {
                targetPath = '768x300';
            }
            else if(sizeX <= 1280)
            {
                targetPath = '1280x500';
            }
            else if(sizeX <= 1600)
            {
                targetPath = '1600x625';
            }
            else if(sizeX <= 1920)
            {
                targetPath = '1920x750';
            }
            else
            {
                targetPath = '2560x1000';
            }

            targetPath = '/bild/header/' + targetPath + "/";

            if(imgSrc.match(/\/448x175\//))
            {
                srcPath = '448x175';
            }
            else if(imgSrc.match(/\/768x300\//))
            {
                srcPath = '768x300';
            }
            else if(imgSrc.match(/\/1280x500\//))
            {
                srcPath = '1280x500';
            }
            else if(imgSrc.match(/\/1600x625\//))
            {
                srcPath = '1600x625';
            }
            else if(imgSrc.match(/\/1920x750\//))
            {
                srcPath = '1920x750';
            }
            else
            {
                srcPath = '2560x1000';
            }
            srcPath = '/bild/header/' + srcPath + "/";
        }

        return imgSrc.replace(srcPath, targetPath);
    }

    switch_slide(newSlideNo)
    {
        this.slides[this.activeSlideNo].classList.remove('active');
        this.slides[newSlideNo].classList.add('active');
        this.activeSlideNo = newSlideNo;
    }
}